import React, { useState } from "react";
import styles from "../Navigation/Navigation.module.css";
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
} from "reactstrap";

import logo from "../../assets/images/logo.png";
import mobileLogo from "../../assets/images/logo-mobile.png";
import { Link } from "react-router-dom";

function Navigation(props) {
  const [isOpen, setIsOpen] = useState(false);
  const toggle = () => setIsOpen(!isOpen);
  
  return (
    <div>
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-12">
            <Navbar expand="md" light className="tech-to-med-navbar">
              <NavbarBrand className={styles.NavbarBrand}>
              <Link to="/login">
                  <img
                    src={logo}
                    className="logo-image d-none d-md-inline-block"
                    alt="TechToMed"
                  />
                  <img
                    src={mobileLogo}
                    alt="TechToMed"
                    className="d-inline-block d-md-none"
                  />
                    <h1>TechToMedix</h1>
                 </Link>
              </NavbarBrand>
              <NavbarToggler onClick={toggle} />
              <Collapse isOpen={isOpen} navbar>
                <Nav className={`ml-auto ${styles.techtomedNav}`} navbar>
                  <NavItem>
                    <NavLink>Home</NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink>Support</NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink>Help</NavLink>
                  </NavItem>
                </Nav>
              </Collapse>
            </Navbar>
          </div>
        </div>
      </div>
    </div>
  );
}
export default Navigation;
